import React, { Component } from 'react';
import './style.scss';

class Progress extends Component {
    render() {
        const { stage, handleClickBack } = this.props;
        const children = React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, { stage, handleClickBack });
        });
        return (
            <div className="progress-container">
                <div className="stepper-progress-background-line-container">
                    <hr className="stepper-progress-background-line" />
                </div>
                {children}
            </div>
        );
    }
}

export default Progress;
